<div #mycontainer *ngIf="hide==false" class="d-flex">
    <div class="d-flex warn-row mat-elevation-z2 " [class.white]="contrast" [class.align-items-center]="enableCompact == false" [class.align-items-start]="enableCompact"   style="gap: 8px; padding: 8px">
        <mat-icon [class.padding8]="enableCompact" class="warn-icon">error</mat-icon>
        <div class="d-flex flex-wrap align-items-center " style="gap: 8px; flex:10 0 0; min-height: 40px; " [class.padding8]="enableCompact">

            <ng-content></ng-content>

            
        </div>
        <div *ngIf="hasClose" style="flex: 1 0 0;">

        </div>
         
        <button *ngIf="hasClose" mat-icon-button>
            <mat-icon class="icon-default" style="transform: scale(0.85); " aria-label="tancar" (click)="doClose()">close</mat-icon>
        </button>
    </div>
</div>
